import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import reset_45page_45state_45global from "/vercel/path0/middleware/reset-page-state.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  reset_45page_45state_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}